/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from "three";
import React, { useState } from "react";
import { Html, PivotControls, useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";
import { ILocation } from "../models/general.model";
import { Typography } from "@mui/material";
import { IHotspot } from "../models/hotspot.model";
import { useControls } from "leva";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import info from "../components/assets/info.svg";
import { ProductModel } from "./ProductModel";
import { ProductOutlineModel } from "./ProductOutlineModel";
import ReactGA from "react-ga4";

type GLTFResult = GLTF & {
  nodes: {
    Circle: THREE.Mesh;
    Circle001: THREE.Mesh;
  };
  materials: {
    ["Material.001"]: THREE.MeshStandardMaterial;
  };
};

interface IProps {
  hotspot: IHotspot;
  // onHotspotClick: any;
  clicked: string;
  setClicked: any;
  clickedOpen: any;
}

export function InformationProduct({
  hotspot,
  clicked,
  setClicked,
  clickedOpen,
}: IProps) {
  const [hover, setOnHover] = useState(false);

  // const controller = useControls({
  //   [`${hotspot.id}-x`]: { value: hotspot.position.x, min: -100, max: 100 },
  //   [`${hotspot.id}-y`]: { value: hotspot.position.y, min: -100, max: 100 },
  //   [`${hotspot.id}-z`]: { value: hotspot.position.z, min: -100, max: 100 },

  //   [`${hotspot.id}-scale`]: { value: hotspot.scale, min: -100, max: 100 },
  // });

  return (
    // <PivotControls
    //   depthTest={false}
    //   anchor={[-10, -10, -10]}
    //   scale={10}
    //   // translationLimits={[
    //   //   [-100, 100],
    //   //   [-100, -40],
    //   //   [-100, 100],
    //   // ]}
    // >
    <ProductOutlineModel
      onClick={() => {
        clickedOpen(hotspot);
        ReactGA.event({
          category: "info-rounded-hotspot-clicked",
          action: JSON.stringify(hotspot),
        });
      }}
      position={[hotspot.position.x, hotspot.position.y, hotspot.position.z]}
      // position={[
      //   controller[`${hotspot.id}-x`],

      //   controller[`${hotspot.id}-y`],

      //   controller[`${hotspot.id}-z`],
      // ]}
    />
    // </PivotControls>
  );
}
